import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { login, formatErrorDetail } from "@/lib/adminApi";
import { ADMIN } from "@/constants/testIds";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Harshita.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErrorDetail(err?.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#0A2342] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white p-10">
        <div className="flex items-baseline gap-1">
          <span className="font-display text-3xl tracking-tight text-[#0A2342] font-bold">
            Invinci
          </span>
          <span className="font-script text-4xl text-[#CBA358] -ml-1">Fy</span>
        </div>
        <h1 className="mt-6 font-display text-3xl text-[#0A2342]">Admin Sign In</h1>
        <p className="mt-2 text-sm text-[#5C636A]">
          Edit your site content, testimonials and view bookings.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div className="space-y-2">
            <Label className="text-[10px] uppercase tracking-[0.22em] text-[#5C636A] font-semibold">
              Email
            </Label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid={ADMIN.loginEmail}
              placeholder="harshita@invincify.in"
              className="rounded-none border-x-0 border-t-0 border-b-2 border-[#E5DFD3] focus-visible:ring-0 focus-visible:border-[#0A2342] px-0"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-[10px] uppercase tracking-[0.22em] text-[#5C636A] font-semibold">
              Password
            </Label>
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid={ADMIN.loginPassword}
              placeholder="••••••••"
              className="rounded-none border-x-0 border-t-0 border-b-2 border-[#E5DFD3] focus-visible:ring-0 focus-visible:border-[#0A2342] px-0"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid={ADMIN.loginSubmit}
            className="w-full bg-[#0A2342] text-white py-3 text-sm uppercase tracking-wider font-medium hover:bg-[#173B63] disabled:opacity-60 transition-colors"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="mt-6 text-xs text-[#5C636A]">
          Forgot password? Contact your developer to reset.
        </p>
      </div>
    </main>
  );
};

export default AdminLogin;
